"use client";

import type { FC } from "react";

import { CtaBlock as CtaBlockUI } from "@jti/ui/components/CtaBlock";

import type { ctaBlockInputs } from "@/components/CtaBlock/CtaBlock.builder";

export type CtaBlockBuilderProps = BuilderComponentProps<typeof ctaBlockInputs>;

export const CtaBlock: FC<CtaBlockBuilderProps> = ({ title, text, ctaText, href }) => {
  return <CtaBlockUI title={title} text={text} ctaText={ctaText} href={href} />;
};
